import React from "react"
import Toggler from "components/Toggler"
import styles from "./styles.scss"
import { AppContext } from "App"
import { useTranslation } from "react-i18next"
import { IProofSetting } from ".."

const ProofSetting: React.FC<{
  settings: IProofSetting
  toggleIsSuggestionMediaOrdersRadio: () => void
  toggleIsVoucherKeyRedio: () => void
  toggleCaseFeeIncludedInOrder: () => void
  toggleIsCaseFeeIncludedInFirstOrder: () => void
  toggleCaseFeeHide: () => void
}> = ({
  settings,
  toggleIsSuggestionMediaOrdersRadio,
  toggleIsVoucherKeyRedio,
  toggleCaseFeeIncludedInOrder,
  toggleIsCaseFeeIncludedInFirstOrder,
  toggleCaseFeeHide
}) => {
  const { t } = useTranslation()


  const isMediaUser = React.useContext(AppContext).currentUserSession.user
    ?.isMediaUser

  return (
    <div className={styles.suggestionMediaOrders}>
      <b className={styles.title}>{t("proof:showHideProofCol")}</b>

        <div>
          <label id="thank-advert">
            <Toggler
              checked={settings.isSuggestionMediaOrders}
              onChange={toggleIsSuggestionMediaOrdersRadio}
            />
            <span>{t("proof:thanksAdSuggest")}</span>
          </label>
        </div>
 

      <div>
        {!isMediaUser && (
          <label   id={"memory-room-key"}>
            <Toggler
              checked={settings.isVoucherKey}
              onChange={toggleIsVoucherKeyRedio}
            
            />
            <span>{t("proof:keyToMemoryRoom")}</span>
          </label>
        )}
      </div>

        <div>
          <label id={"case-fee-included-orders"}>
            <Toggler
              checked={settings.isCaseFeeIncludedInOrders}
              onChange={toggleCaseFeeIncludedInOrder}
            />
            {/* <span>{t("proof:casePrise")} ALIS och<span title="Familjesidan.se">FS*</span>{" " + t("proof:widthAllAdverts")}</span> */}
            <span>{t("proof:caseFeeIncludedInOrders")}</span>
          </label>
        </div>

        <div>
          <label id={"case-fee-main-order"}>
            <Toggler
              checked={settings.isCaseFeeIncludedInFirstOrder}
              onChange={toggleIsCaseFeeIncludedInFirstOrder}
            />
            {/* <span>{t("proof:casePrise")} ALIS och<span title="Familjesidan.se">FS*</span>{" " + t("proof:withFirstAdvert")}</span> */}
            <span>{t("proof:caseFeeWithMainOrder")}</span>
          </label>
        </div>

        <div>
          <label id={"exclude-case-price"}>
            <Toggler
              checked={settings.isCaseFeeHide}
              onChange={toggleCaseFeeHide}
            />
            {/* <span>{t("proof:exclude") + " " + t("proof:theCasePrise")} ALIS och<span title="Familjesidan.se">FS*</span></span> */}
            <span>{t("proof:excludeCasePrice")}</span>
          </label>
        </div>

    </div>
  )
}

export default ProofSetting
